import * as React from 'react';
import { Button } from 'antd';
import { observer } from 'mobx-react';

interface HeaderViewProps {
	contextService: { isDirty: boolean };
	title: string,
	save: () => void,
	cancel: () => void,
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	hideBackButton?: boolean;
	hideModifyButtons?: boolean;
}

@observer
export class HeaderView extends React.Component<HeaderViewProps, {}> {
	handleClick = (): void => {
		if (this.props.onModeChanged != null) {
			this.props.onModeChanged(this.props.mode == 'edit' ? 'display' : 'edit');
		}
	};

	render(): React.ReactNode {
		return (
			<div className="card header">
				<Button.Group>
					{
						!this.props.hideModifyButtons && this.props.mode === 'display' &&
						<Button onClick={this.handleClick} icon="edit">Edit</Button>
					}
					{
						!this.props.hideBackButton &&
						<Button icon="rollback" onClick={this.props.cancel}>Back</Button>
					}
					{
						!this.props.hideModifyButtons && this.props.mode === 'edit' &&
						<Button icon="save" onClick={this.props.save} disabled={!this.props.contextService.isDirty}>Save</Button>
					}
					{
						!this.props.hideModifyButtons && this.props.mode === 'edit' &&
						<Button icon="close-circle" onClick={this.props.hideBackButton ? this.props.cancel : this.handleClick}>Cancel</Button>
					}
				</Button.Group>
				<strong style={{ margin: "0 0 0 10px" }}>
					{this.props.title}
				</strong>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/header.view.tsx